import React, { memo, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import sb from 'sendbird';
import {
    getUserInfo, getFarmInfo, getAppState,
    getSettings as getSettingsFromSession,
    getOrganizationInfo, getChatAppId,
    setScaleMachineDetails,
    getScaleMachineDetails
} from '../helpers/session';
import { loginSuccess } from '../actions/auth';
import { farmOrganization } from '../actions/organization';
import { getSettings, getUserFarmConfiguration, refreshSettings } from '../actions/user';
import { getFarmAddress, setCurrentFarm } from '../actions/farm';
import { mapAutoZoom } from '../actions/map';
import { getQRSeceretKeys } from '../actions/auth';
import { getUnreadMessageCount, setUnreadMessageCount } from '../actions/chat';
import Home from './Home';
import Autologout from './AutoLogout';
import { getRemoteScaleInfo } from '../actions/remote-scale';
import { validateCollections } from '../helpers/common';
import { scaleDeviceList } from '../actions/scale-device';

let unreadMessageCountTimerId = null;

const HomeWithPersist = props => {

    const dispatch = useDispatch();
    const userInfo = useSelector(state => state.auth.userInfo);
    const settings = useSelector(state => state.user.settings);
    const farmSettings = useSelector(state => state.farm.farmSettings.farm_config);
    const isStopUnreadMessageCount = useSelector(state => state.chat.isStopUnreadMessageCount);

    const { ...rest } = props;
    const { farmId } = props.match.params;
    const { remote_scale_socket = {} } = farmSettings || {};
    const isRemoteScaleEnable = (remote_scale_socket && remote_scale_socket.visible);
    const [unreadMessageCount, setMessageCount] = useState(0);
 
    const scaleInfo = useSelector(state => state.scaleDevice.scaleInfo);
    const scaleDetails = validateCollections(scaleInfo) ? scaleInfo : [];

    const appId = getChatAppId();
    const sbChat = new sb({ appId });
    const userEventHandler = new sbChat.UserEventHandler();
    sbChat.addUserEventHandler("userEventHandler", userEventHandler);
    userEventHandler.onTotalUnreadMessageCountUpdated = totalCount => setMessageCount(totalCount);

    const getMessageCount = () => dispatch(getUnreadMessageCount());

    useEffect(() => {
        // GET SETTINGS
        if (settings === false) {
            const settings = getSettingsFromSession();
            settings ? dispatch(refreshSettings()) : dispatch(getSettings());
        } else dispatch(refreshSettings());

        //GETTING UNREAD MESSAGE COUNT WITH THE INTERVAL OF 5 MINUTES
        getMessageCount();
        listenUnreadMessageCount(false);

        dispatch(getQRSeceretKeys());
        if (farmId) dispatch(getUserFarmConfiguration({ farmId }));
        if (farmId) {
            dispatch(getFarmAddress(farmId));
        }

        if (userInfo) return;
        dispatch(setCurrentFarm(getFarmInfo()));
        dispatch(farmOrganization(getOrganizationInfo()));
        dispatch(loginSuccess(getUserInfo()));

        // APP STATE
        const appState = getAppState();
        if (appState.isAutoZoom) dispatch(mapAutoZoom(true));

        return (() => {
            listenUnreadMessageCount(true);
        })
    }, []);

    useEffect(() => {
        const params = { unread_count: unreadMessageCount }
        dispatch(setUnreadMessageCount(params));
    }, [unreadMessageCount]);

    useEffect(() => {
        if (isStopUnreadMessageCount) listenUnreadMessageCount(true);
    }, [isStopUnreadMessageCount]);

    const listenUnreadMessageCount = (isStop) => {
        if (isStop) {
            unreadMessageCountTimerId && clearInterval(unreadMessageCountTimerId);
            return;
        }

        unreadMessageCountTimerId = setInterval(getMessageCount, 5 * 60 * 1000);
    };

    const scaleCb = (isSacleAvailable, data) => {
        const scaleId = (data && data.scale_device_uuid) ? data && data.scale_device_uuid : null;
        if (!isSacleAvailable && !scaleId) {
            dispatch(getRemoteScaleInfo({ scaleURL: 'https://scale.acuitusag.local:4443' }, scaleRetryCb));
        } else {
            setScleInfo({ scaleDeviceId: scaleId });
        }
    }

    const scaleRetryCb = (isSacleAvailable, data) => {
        const scaleId = (data && data.scale_device_uuid) ? data && data.scale_device_uuid : null;
        if (isSacleAvailable && scaleId) {
            setScleInfo(
                {
                    scaleDeviceId: scaleId,
                    scaleAPIURL: 'https://scale.acuitusag.local:4443',
                    scaleSocketURL: 'wss://scale.acuitusag.local:4443'
                }
            );
        }
    }

    const setScleInfo = (data) => {
        const scaleId = (data && data.scaleDeviceId) ? data && data.scaleDeviceId : null;
        const filteredScaleInfo = scaleDetails.filter(it => it.scale_device_uuid === scaleId);
        const scaleDeviceName = validateCollections(filteredScaleInfo) && filteredScaleInfo[0].name ? filteredScaleInfo[0].name : "";
        if (scaleId) {
            setScaleMachineDetails({ ...data, name: scaleDeviceName })
        }
    }

    useEffect(() => {
        if (isRemoteScaleEnable) dispatch(getRemoteScaleInfo(null, scaleCb));
    }, [isRemoteScaleEnable])

    useEffect(() => {
        const params = {
            farm_uuid: farmId
        }
        dispatch(scaleDeviceList(params));
    }, []);

    useEffect(() => {
        const getScaleDeviceDetails = getScaleMachineDetails();
        const getScaleId = getScaleDeviceDetails && getScaleDeviceDetails.scaleDeviceId ?
            getScaleDeviceDetails.scaleDeviceId : "";
        if (validateCollections(scaleDetails)) {
            const filteredScaleInfo = scaleDetails.filter(it => it.scale_device_uuid === getScaleId);
            const scaleDeviceName = validateCollections(filteredScaleInfo) && filteredScaleInfo[0].name ? filteredScaleInfo[0].name : "";
            const scaleDeviceId = validateCollections(filteredScaleInfo) && filteredScaleInfo[0].scale_device_uuid ? filteredScaleInfo[0].scale_device_uuid : "";
            setScaleMachineDetails({ scaleDeviceId, name: scaleDeviceName });
        }
    }, [scaleInfo]);

    return userInfo
        ? <Autologout> <Home {...rest} /> </Autologout>
        : <></>;
};
export default memo(HomeWithPersist);